import { app } from '@microsoft/teams-js';

export type ExpectedFailureReason = app.ExpectedFailureReason;
export type FailedReason = app.FailedReason;
export const { ExpectedFailureReason, FailedReason } = app;

export class MetaOsHubNotFoundError extends Error {
  public readonly name: string = 'MetaOsHubNotFoundError';

  constructor(message?: string) {
    super(message);
  }
}
